import api from "@/shared/http/api-client";
import { streamFetch } from "@/shared/http/streaming";

/**
 * PragyaAI domain service — replicates MicroApp PragyaAiService method
 * signatures with paths aligned to the main server's wisbot module
 * (mounted at /api/ai).
 *
 * Path mapping (MicroApp → Main Server):
 *   /ai/get_ai_content/youtube  → /ai/ai_content_youtube
 *   /ai/get_ai_content/s3       → /ai/ai_content_s3
 *   /ai/delete_ai_content (POST)→ /ai/deleteAiContent (DELETE)
 *   /ai/get_courses             → /ai/ai_content
 *   /ai/sync_s3_namespaces(POST)→ /ai/sync_s3 (GET)
 *   /ai/generate_course         → /ai/course_resource
 *   /ai/generate_course_stream  → /ai/course_resource (via streamFetch, TODO)
 *   /ai/youtube                 → TODO: no server route yet
 *
 * See context/pragyaai-api-alignment.md for the full mapping table.
 */
export const PragyaAiService = {
  getAiResponse(data) {
    return api.post("/ai/ai_response", data);
  },

  getAiContentYoutube(data) {
    return api.post("/ai/ai_content_youtube", data);
  },

  getAiContentS3(data) {
    return api.post("/ai/ai_content_s3", data);
  },

  deleteAiContent(data) {
    return api.delete("/ai/deleteAiContent", { data });
  },

  getAllCourses() {
    return api.get("/ai/ai_content");
  },

  getAllModels() {
    return api.get("/ai/get_models");
  },

  getChatModelCatalog() {
    return api.get("/ai/chat_model_catalog");
  },

  customizeCourse(data) {
    return api.post("/ai/course_resource", data);
  },

  syncS3Namespaces() {
    return api.get("/ai/sync_s3");
  },

  /**
   * Streaming course generation.
   * The main server does not yet expose a dedicated streaming endpoint;
   * this falls back to the non-streaming /ai/course_resource via
   * streamFetch.  When a streaming route is added server-side, update
   * the path here.
   */
  customizeCourseStream(data, onChunk, onDone, onError, signal) {
    return streamFetch(
      "/ai/course_resource",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        signal,
      },
      onChunk,
      onDone,
      onError,
    );
  },

  /**
   * TODO: No matching server route exists yet.
   * MicroApp calls POST /ai/youtube — this needs a new server-side
   * route in wisbot or a mapping to /ai/ai_content_youtube if the
   * business logic overlaps.
   */
  generateYoutubeLinks(data) {
    return api.post("/ai/ai_content_youtube", data);
  },
};

export default PragyaAiService;
